type JsonPrimitive = boolean | null | number | string;
type JsonValue = JsonPrimitive | readonly JsonValue[] | { readonly [key: string]: JsonValue };

function normalize(value: unknown): JsonValue {
  if (value === null || typeof value === "boolean" || typeof value === "string") return value;
  if (typeof value === "number" && Number.isFinite(value)) return value;
  if (Array.isArray(value)) return value.map(normalize);

  if (typeof value === "object") {
    const normalized: Record<string, JsonValue> = {};
    for (const key of Object.keys(value).sort()) {
      const property = (value as Record<string, unknown>)[key];
      if (property === undefined)
        throw new Error("Canonical JSON cannot contain undefined values.");
      normalized[key] = normalize(property);
    }
    return normalized;
  }

  throw new Error("Canonical JSON contains a non-JSON value.");
}

export function canonicalJson(value: unknown): string {
  return JSON.stringify(normalize(value));
}
